// Ignores the first argument (the operator token) and passes the second through unchanged.
export const always = (_token, value) => value
